import { useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Grid } from "@mui/material";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

//import utils
import { calculateDateDifferenceInDays } from "../../../utils/date";

//import constants
import { IS_MOBILE } from "../../../constants/breakpoints";
import BASE_URL from "../../../constants/baseUrls";

//import general components
import { BaseButton } from "../../common/base-button/base-button";
import Loading from "../../common/loading/loading";
import BaseTitle from "../../common/base-title/base-title";

//import view components
import HotelRoomItem from "./hotel-room-item";
import IntHotelRoomsItem from "./int-hotel-room-item";

//import images and icons
import { ArrowForward } from "iconsax-react";

//import sryles
import "./int-hotel-room-item.scss";

function HotelRooms() {
    //general variables
    let [searchParams, setSearchParams] = useSearchParams();
    const { t } = useTranslation();

    //sessionStorage variables
    const { checkIn, checkOut, nationality, roomsCount } = JSON.parse(sessionStorage.getItem("hotelInformation"));
    const { isHotelInternational } = JSON.parse(sessionStorage.getItem("generalInformation"));
    const selectedHotel = JSON.parse(sessionStorage.getItem("selectedHotel"));
    const hotelTag = searchParams.get("tag");

    //request room list
    const [roomList, setRoomList] = useState();
    const [roomListLoading, setRoomListLoading] = useState();
    const getRoomList = async endPoint => {
        try {
            setRoomListLoading(true);
            const response = await axios.get(`${BASE_URL}${endPoint}`, {
                params: {
                    check_in: checkIn,
                    check_out: checkOut,
                    hotel: searchParams.get("hotelId"),
                    id: searchParams.get("hotelId"),
                    adult_count: roomsCount.adult,
                    child_count: roomsCount.child,
                    child_ages: roomsCount.ages,
                    nationality: nationality?.parto_iata,
                    tag: selectedHotel?.tag,
                },
            });

            setRoomList(response.data.data);
        } catch (error) {
            toast.error(error?.response?.data?.errors?.detail || t("errorMessage"), { toastId: "custom-id-yes" });
            backToHotelList();
        } finally {
            setRoomListLoading(false);
        }
    };
    useEffect(() => {
        const endPoint =
            hotelTag === "pr" || isHotelInternational ? "/api/v2/reserve/foreign/accommodation/detail/" : "/reserve/accommodation/detail/";
        getRoomList(endPoint);
    }, []);

    //back to hotel list
    const backToHotelList = () => {
        searchParams.delete("hotelId");
        searchParams.delete("action");
        searchParams.delete("tag");
        setSearchParams(searchParams);
    };

    // Calculate the length of stay (in days) between check-in and check-out dates
    const dateLength = useMemo(() => {
        return calculateDateDifferenceInDays(checkIn, checkOut);
    }, [checkIn, checkOut]);

    return (
        <Grid container item xs={12} rowGap={5} justifyContent="center">
            {roomListLoading && <Loading />}

            {!IS_MOBILE && (
                <BaseTitle
                    title={`${t("roomList")} ${selectedHotel?.name}`}
                    dividerColor="1px solid var(--medium-gray-color)"
                    button={
                        <BaseButton
                            text={t("returnToHotel")}
                            color="outline-dark"
                            radius="radius-10"
                            size="small"
                            rightIcon={<ArrowForward size="16" color="var(--teal-color-18)" />}
                            handleClick={backToHotelList}
                        />
                    }
                />
            )}

            {hotelTag === "grs" && <HotelRoomItem hotelDetails={roomList} dateLength={dateLength} />}
            {hotelTag === "pr" && <IntHotelRoomsItem roomList={roomList} />}
        </Grid>
    );
}

export default HotelRooms;
